import React from "react"
import { useState } from "react"
import { Carousel, CarouselItem, CarouselIndicators } from "reactstrap"

import Testimonials from "./testimonials"

import { REGISTER_PAGE_TESTIMONIALS } from "../../helpers/constants"

const CarouselComponent = () => {
  const [activeIndex, setActiveIndex] = useState(0)
  const [animating, setAnimating] = useState(false)

  const next = () => {
    if (animating) return
    const nextIndex = activeIndex === REGISTER_PAGE_TESTIMONIALS.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex)
  }

  const previous = () => {
    if (animating) return
    const nextIndex = activeIndex === 0 ? REGISTER_PAGE_TESTIMONIALS.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex)
  }

  const goToIndex = (newIndex) => {
    if (animating) return
    setActiveIndex(newIndex)
  }

  const slides = REGISTER_PAGE_TESTIMONIALS.map((item) => {
    return (
      <CarouselItem
        key={item.key}
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
      >
        <Testimonials item={item} />
      </CarouselItem>
    )
  })

  return (
    <Carousel
      interval={6000}
      ride="carousel"
      activeIndex={activeIndex}
      next={next}
      previous={previous}
      keyboard={false}
    >

      {slides}
      <CarouselIndicators items={REGISTER_PAGE_TESTIMONIALS} activeIndex={activeIndex} onClickHandler={goToIndex} />
    </Carousel>
  )
}

export default CarouselComponent;